import Chart from 'chart.js/auto';

export const ExchangeStatusDonutChart = {
  mounted() {
    this.chart = null;
    this.checkInterval = null;

    this.checkInterval = setInterval(() => {
      const isVisible = this.el.style.visibility !== 'hidden';
      const rect = this.el.parentElement.getBoundingClientRect();
      if (isVisible && rect.width > 0 && rect.height > 0) {
        clearInterval(this.checkInterval);
        this.initChart();
      }
    }, 100);
  },

  updated() {
    if (this.chart) this.updateChart();
  },

  destroyed() {
    if (this.checkInterval) clearInterval(this.checkInterval);
    if (this.chart) this.chart.destroy();
  },

  getData() {
    return {
      completed: parseInt(this.el.dataset.completed) || 0,
      stillToDeliver: parseInt(this.el.dataset.stillToDeliver) || 0
    };
  },

  initChart() {
    const ctx = this.el.getContext('2d');
    const { completed, stillToDeliver } = this.getData();

    this.chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: ['Completed', 'Still to Deliver'],
        datasets: [{
          data: [completed, stillToDeliver],
          backgroundColor: ['#10B981', '#F59E0B'],
          borderColor: '#ffffff',
          borderWidth: 2
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              padding: 15,
              font: { size: 12, weight: 'bold' },
              usePointStyle: true,
              pointStyle: 'circle',
              generateLabels(chart) {
                const data = chart.data;
                if (!data.labels.length || !data.datasets.length) return [];
                const total = data.datasets[0].data.reduce((a, b) => a + b, 0);
                return data.labels.map((label, i) => {
                  const value = data.datasets[0].data[i];
                  const pct = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                  return {
                    text: `${label}: ${value} (${pct}%)`,
                    fillStyle: data.datasets[0].backgroundColor[i],
                    hidden: false,
                    index: i
                  };
                });
              }
            }
          },
          tooltip: {
            callbacks: {
              label(context) {
                const value = context.parsed || 0;
                const total = context.dataset.data.reduce((a, b) => a + b, 0);
                const pct = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                return `${context.label}: ${value} (${pct}%)`;
              }
            }
          }
        },
        cutout: '65%'
      }
    });
  },

  updateChart() {
    if (!this.chart) return;
    const { completed, stillToDeliver } = this.getData();
    this.chart.data.datasets[0].data = [completed, stillToDeliver];
    this.chart.update('none');
  }
};

export const ExchangeByTenantBarChart = {
  mounted() {
    this.chart = null;
    this.checkInterval = null;

    this.checkInterval = setInterval(() => {
      const isVisible = this.el.style.visibility !== 'hidden';
      const rect = this.el.parentElement.getBoundingClientRect();
      if (isVisible && rect.width > 0 && rect.height > 0) {
        clearInterval(this.checkInterval);
        this.initChart();
      }
    }, 100);
  },

  updated() {
    if (this.chart) this.updateChart();
  },

  destroyed() {
    if (this.checkInterval) clearInterval(this.checkInterval);
    if (this.chart) this.chart.destroy();
  },

  getSortedData() {
    const raw = JSON.parse(this.el.dataset.tenants || '[]');
    return raw
      .map(t => ({
        name: t.tenant_name || t.name || 'Unknown',
        completed: t.completed || 0,
        stillToDeliver: t.still_to_deliver || 0
      }))
      .filter(t => t.completed > 0 || t.stillToDeliver > 0)
      .sort((a, b) => b.stillToDeliver - a.stillToDeliver)
      .slice(0, 10);
  },

  shorten(name) {
    return name && name.length > 25 ? name.substring(0, 25) + '...' : (name || 'Unknown');
  },

  initChart() {
    const ctx = this.el.getContext('2d');
    const data = this.getSortedData();
    if (!data.length) return;

    const labels = data.map(t => this.shorten(t.name));

    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels,
        datasets: [
          {
            label: 'Completed',
            data: data.map(t => t.completed),
            backgroundColor: '#10B981',
            borderColor: '#059669',
            borderWidth: 2,
            borderRadius: 6
          },
          {
            label: 'Still to Deliver',
            data: data.map(t => t.stillToDeliver),
            backgroundColor: '#F59E0B',
            borderColor: '#B45309',
            borderWidth: 2,
            borderRadius: 6
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              padding: 10,
              font: { size: 12, weight: 'bold' },
              usePointStyle: true,
              pointStyle: 'circle'
            }
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const t = data[context.dataIndex];
                const total = t.completed + t.stillToDeliver;
                return [
                  `${context.dataset.label}: ${context.parsed.x}`,
                  `Total Flagged: ${total}`
                ];
              },
              title: (items) => data[items[0].dataIndex].name
            }
          }
        },
        scales: {
          x: {
            stacked: true,
            beginAtZero: true,
            grid: { display: true, color: 'rgba(0, 0, 0, 0.05)' }
          },
          y: {
            stacked: true,
            grid: { display: false },
            ticks: { font: { size: 11, weight: 'bold' } }
          }
        }
      }
    });
  },

  updateChart() {
    if (!this.chart) return;
    const data = this.getSortedData();
    this.chart.data.labels = data.map(t => this.shorten(t.name));
    this.chart.data.datasets[0].data = data.map(t => t.completed);
    this.chart.data.datasets[1].data = data.map(t => t.stillToDeliver);
    this.chart.update('none');
  }
};